// angular
// 	.module("HeroPRO")
// 	.controller("ProjectInformationController", projectInformationController);

import _ from 'lodash';

/* @ngInject */
export default function projectInformationController(FRClosingFactory) {
    const vm = this;
    vm.projectDetails = {};
    vm.paymentInstructions = {};
    vm.isProjectDetailsDisplayed = false;
    vm.isLoaded = false;
    vm.isPaymentInstructionsDisplayed = false;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        FRClosingFactory.getFundingRequestClosingPromise().then(() => {
            vm.projectDetails = FRClosingFactory.getProjectDetails();
            vm.paymentInstructions = FRClosingFactory.getPaymentInstructions();
            vm.isProjectDetailsDisplayed = !_.isEmpty(vm.projectDetails);
            vm.isPaymentInstructionsDisplayed = !_.isEmpty(vm.paymentInstructions) && vm.paymentInstructions.InitialRequested !== undefined;
            vm.isLoaded = true;
        });
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/appDetail/projectInformation/projectInformationController.js